import React from 'react';
import { localize } from 'react-localize-redux';
import EmergencyContactsFieldArray from 'components/shared/EmergencyContactsFieldArray';
import EmergencyContactsFieldArrayOutlined from 'components/shared/EmergencyContactsFieldArrayOutlined';
import { FieldArray } from 'redux-form';

class RenderEmergencyContacts extends React.Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    return (
      <EmergencyContactsFieldArray
        startDeletingAtIndex={this.props.startDeletingAtIndex}
        {...this.props}
      />
    );
  }
}

class RenderEmergencyContactsNewMUI extends React.Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    return (
      <EmergencyContactsFieldArrayOutlined
        startDeletingAtIndex={this.props.startDeletingAtIndex}
        {...this.props}
      />
    );
  }
}

class EmergencyContacts extends React.Component {
  render() {
    return (
      <div className="row">
        {this._renderTitle()}
        {this._renderOldMUIForm()}
        {this._renderMUIForm()}
      </div>
    );
  }

  _renderOldMUIForm = () => {
    if (this.props.newMUI) return;

    return (
      <FieldArray
        name="emergency_contacts"
        startDeletingAtIndex={this.props.startDeletingAtIndex}
        component={RenderEmergencyContacts}
      />
    );
  };

  _renderMUIForm = () => {
    if (!this.props.newMUI) return;

    return (
      <FieldArray
        name="emergency_contacts"
        startDeletingAtIndex={this.props.startDeletingAtIndex}
        component={RenderEmergencyContactsNewMUI}
      />
    );
  };

  _renderTitle = () => {
    if (this.props.newMUI) return;

    return (
      <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
        {this.props.translate('landlordPortal.emergencyContacts.emergencyContactDetails')}
      </h5>
    );
  };
}

export default localize()(EmergencyContacts);
